import { useQuery } from "@tanstack/react-query"

import { CUSTOMER_SETTING_QUERY_KEY } from "@/constants/query"
import { getSettingsByUser } from "@/http/customerSettings"


export const useSettingsByUser = () => {
    return useQuery({
        queryFn: () => getSettingsByUser(),
        queryKey: [CUSTOMER_SETTING_QUERY_KEY],
        retry: false
      })
}